export const notificationMessage = {
  LOGIN_SUCCESS: "Welcome back",
  PERMISSIONS_ERROR: "Access is denied",
  LPS_CALCULATION_START: "LPS calculation started!",
  LPS_CALCULATION_FINISH: "LPS calculation completed!",
  BASE_ERROR_MESSAGE: "Ops! Something went wrong!",
  TEST_MESSAGE: "This is test notification message",
  LPS_CONFIG_DELETE_NOT_FOUND: "Config already removed or not found",
  ALLOWED_CHARACTERS_ERROR: "Allowed: A-Z, 0-9, space,',-",
  LABEL_UPDATE_SUCCESS: 'Label successfully updated!',
  LABEL_CREATE_SUCCESS: 'Label successfully created!',
  LABEL_DELETE_SUCCESS: 'Label successfully removed!',
  TAG_UPDATE_SUCCESS: 'Tag successfully updated!',
  TAG_DELETE_SUCCESS: 'Tag successfully removed!',
  TAG_CREATE_SUCCESS: 'Tag successfully created!',
  BAD_REQUEST: 'Bad request',
  UNAUTHORIZED: 'Unauthorized',
  FORBIDDEN_ERROR: 'Forbidden',
  NOT_FOUND: 'Not Found',
  REQUEST_ERROR: 'Request Error',
};
